module.exports = __webpack_public_path__ + "img/Sold_out.2c437f92.svg";